import './App.css';

import ProfileImage from './components/ProfileImage';
import GuestBook from './components/GuestBook';
import Weather from './components/Weather';
import Playground from './components/Playground';

function App() {
  if (window.location.pathname === '/playground') {
    return <Playground />;
  }

  return (
    <div className="App">
      <nav className="site-nav">
        <a className="site-link" href="/playground">
          Playground
        </a>
      </nav>
      <h1>Hi, I'm Sterling</h1>
      <ProfileImage />
      <p> Programmer - Engineer - Renaissance Man</p>
      <p> This website was made in an afternoon to refresh my React Skills</p>

      <Weather />

      <GuestBook />
    </div>
  );
}

export default App;
